/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for FolderResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetFolderByIdResponse, GetFoldersResponse } from "../models";

@Injectable({ providedIn: "root" })
export class FolderResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getFolderById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetFolderByIdResponse, unknown> & { defaultValue: NoInfer<GetFolderByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFolderByIdResponse>;
    getFolderById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetFolderByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFolderByIdResponse | undefined>;
    getFolderById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetFolderByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFolderByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Folder/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getFolders(parentId: Signal<number | null | undefined> | number | null | undefined, searchText: Signal<string | null | undefined> | string | null | undefined, resourceOptions: HttpResourceOptions<GetFoldersResponse, unknown> & { defaultValue: NoInfer<GetFoldersResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFoldersResponse>;
    getFolders(parentId?: Signal<number | null | undefined> | number | null, searchText?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetFoldersResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFoldersResponse | undefined>;
    getFolders(parentId?: Signal<number | null | undefined> | number | null, searchText?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetFoldersResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetFoldersResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const parentIdValue = typeof parentId === 'function' ? parentId() : parentId;
            if (parentIdValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, parentIdValue, 'parentId');
            }
            const searchTextValue = typeof searchText === 'function' ? searchText() : searchText;
            if (searchTextValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, searchTextValue, 'searchText');
            }
            return {
                url: `${this.basePath}/Folder`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
